// extracted by mini-css-extract-plugin
export default {"select-pill-wrapper":"styles_select-pill-wrapper__rArpU","arrow-right-icon":"styles_arrow-right-icon__1EMf+","div-pill":"styles_div-pill__ac2tc","versus":"styles_versus__UDdWq"};